import cs_cz from "../../intl/compiled/cs-CZ.json";
import de_de from "../../intl/compiled/de-DE.json";
import en_gb from "../../intl/compiled/en-US.json";
import es_es from "../../intl/compiled/es-ES.json";
import fr_fr from "../../intl/compiled/fr-FR.json";
import hr_hr from "../../intl/compiled/hr-HR.json";
import hu_hu from "../../intl/compiled/hu-HU.json";
import it_it from "../../intl/compiled/it-IT.json";
import nl_nl from "../../intl/compiled/nl-NL.json";
import pl_pl from "../../intl/compiled/pl-PL.json";
import pt_pt from "../../intl/compiled/pt-PT.json";
import sk_sk from "../../intl/compiled/sk-SK.json";
import { SupportedLocale } from "./constants";

export const getMessages = (locale: SupportedLocale) => {
	return {
		en_gb,
		fr_fr,
		es_es,
		de_de,
		cs_cz,
		hr_hr,
		it_it,
		pl_pl,
		pt_pt,
		hu_hu,
		nl_nl,
		sk_sk,
	}[locale.toLowerCase().replaceAll("-", "_")];
};
